import React,{useState} from 'react'
import * as images from '../assets/img/index'

const PhotoBook = () => {
  const [index, setIndex] = useState(0);
const length = 311
  const handleNext = () => {
    const newIndex = index + 1;
    if (newIndex < length) {
      setIndex(newIndex);
    } else {
      setIndex(0);
    }
  }

  const handlePrevious = () => {
    const newIndex = index - 1;
    if (newIndex >= 0) {
      setIndex(newIndex);
    } else {
      setIndex(length - 1);
    }
  }

  return (
    <>
    <div className="imgLoader"></div>

    <div className="section">
    
      <h1 className="title">
         AI text prompted images & filler misc.<br/>
      </h1>
    
      <div className="credit">
      </div>
    
      <div className="book m-4">
        <div className="gap"></div>
        <div className="pages">
          <div className="page"></div>
          <div className="page"></div>
          <div className="page"></div>
          <div className="page"></div>
          <div className="page"></div>
          <div className="page"></div>
        </div>
        <div className="flips">
          <div className="flip flip1">
            <div className="flip flip2">
              <div className="flip flip3">
                <div className="flip flip4">
                  <div className="flip flip5">
                    <div className="flip flip6">
                      <div className="flip flip7"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div className="carousel">
      <div className="carousel-inner">
  

{Object.keys(images).map((image, idx) => (
            <div
              className={`carousel-item ${index === idx ? 'active' : ''}`}
              key={`image-${idx}`}
            >
              <img src={images[image]} className="carousel-image" alt={image} />
            </div>
          ))}
          <a
            className="carousel-control-prev btn fit"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
            onClick={handlePrevious}
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next btn fit"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
            onClick={handleNext}
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>



<br/>
<div className='line'></div>
    <a className='back-link' href="/">back home</a>

    </>
  )
}

export default PhotoBook